// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39059":"b8e9f051","50502":"3cb70c85","56367":"fde5b732","73582":"2d6dfd79","75120":"45027b11"}[chunkId] + ".chunk.css";
};